import { useEffect, useState } from 'react'

import { useDebounce } from './useDebounce'

/**windowがスクロールしているか判定するhook */
export const useScrolling = () => {
  const [isScrolling, setIsScrolling] = useState(false)
  const debounce = useDebounce(500)

  const handleScrolling = () => {
    setIsScrolling(true)
    debounce(() => {
      setIsScrolling(false)
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScrolling)

    return () => {
      window.removeEventListener('scroll', handleScrolling)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return isScrolling
}
